import React, {PropsWithChildren} from "react";
import { observer } from "mobx-react";
import { OrbitComponent } from "../../base-components/orbit-component/orbit-component";
import { SideMenuItemContainerBox } from "./boxes/item/side-menu-item-container.box";
import { CyClass } from "../../../../common/cy-classes";
import classNames from 'classnames';


interface SideMenuItemContainerComponentProps extends PropsWithChildren {
    className?: string;
    onClick?: () => void;
}


@observer
export class SideMenuItemContainerComponent extends OrbitComponent<SideMenuItemContainerComponentProps> {
    render() {

        return <SideMenuItemContainerBox className={classNames(CyClass("cy-menu-item"), this.props.className)} onClick={this.props.onClick}>
            { this.props.children }
        </SideMenuItemContainerBox>;
    }
}
